import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import userService from '../services/user.service';

const initialState = {
  changePasswordModal: false,
  loginModal: false,
  data: [],
  loading: false,
};

export const changePassword = createAsyncThunk(
  'modal/changepass',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await userService.changePassword(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const sendOTP = createAsyncThunk('modal/sendOTP', async (payload, { rejectWithValue }) => {
  try {
    const response = await userService.getOTP(payload);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    changePasswordModal(state, action) {
      state.changePasswordModal = action.payload;
    },
    setLoginModal(state, action) {
      state.loginModal = action.payload;
    },
    resetSuccess(state) {
      state.success = false;
    },
    cleanUpState(state) {
      state.message = initialState.message;
      state.loading = initialState.loading;
      state.loginModal = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changePassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(changePassword.fulfilled, (state, action) => {
      const data = JSON.parse(localStorage.getItem('userInfo'));
      data.firstTimeLogin = action.payload.data.firstTimeLogin;
      localStorage.setItem('userInfo', JSON.stringify(data));
      state.loading = false;
    });
    builder.addCase(changePassword.rejected, (state, action) => {
      const { code, message } = action.payload.alerts[0];
      if (code === 'IEM021' || code === 'IEM022') {
        state.index = 4;
        state.message = code;
      } else if (code === 'IEM002') {
        state.index = 1;
        state.message = message;
      } else if (code === 'IEM006' || code === 'IEM004') {
        state.index = 2;
        state.message = code;
      } else if (code === 'IEM005') {
        state.index = 3;
        state.message = code;
      } else {
        state.index = 1;
        state.message = code;
      }
      state.loading = false;
      state.success = false;
    });
  },
});

export const { changePasswordModal, resetSuccess, cleanUpState, setLoginModal } =
  modalSlice.actions;
export default modalSlice.reducer;
